import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface WrapperProps {
  $error?: boolean;
  $disabled?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  --height: ${(props) => props.theme.distances.inputHeight};
  --gutter-inline: ${size(1.5)};
  --gutter-block: ${size(1)};
  --text-size: 16px;
  --line-height: 1.3; // Required to prevent text clipping
  --text-offset-block-end: 0;
  --text-offset-block-start: 0;
  --icon-size: ${size(2.5)};
  --border-color: var(--c-border-main);

  position: relative;
  background-color: var(--c-accent-bg);
  border-bottom: 1px solid var(--border-color-override, var(--border-color));
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);

  &:focus-within {
    --border-color: var(--c-border-alt);
  }

  ${({ $error }) =>
    $error &&
    css`
      --border-color-override: var(--c-input-error-border);
      --label-color-override: var(--c-input-error-text);
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.37;
      cursor: not-allowed;
    `}
`;

export const Icon = styled.div`
  position: absolute;
  top: 50%;
  right: var(--gutter-inline);
  transform: translateY(-50%);
  font-size: var(--icon-size);
  user-select: none;
  pointer-events: none;
`;

export const Select = styled.select`
  position: relative;
  display: block;
  width: 100%;
  height: var(--height);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  text-indent: 0.01px;
  border: 0;
  padding-top: var(--text-offset-block-start);
  padding-bottom: var(--text-offset-block-end);
  padding-left: var(--gutter-inline);
  padding-right: calc(var(--icon-size) + var(--gutter-inline));
  background-color: transparent;
  color: var(--c-accent-fg);
  border-radius: 0;
  font-size: var(--text-size);
  cursor: pointer;
  z-index: 1;

  :focus {
    outline: none;
  }

  ::-ms-expand {
    display: none;
  }

  ::-moz-focus-inner {
    border: 0;
  }
`;

export const Option = styled.option`
  color: var(--c-accent-fg);
`;

export const Label = styled.div`
  position: absolute;
  top: var(--gutter-block);
  left: var(--gutter-inline);
  right: var(--gutter-inline);
  display: flex;
  align-items: center;
  gap: ${size(0.5)};
  font-size: ${(props) => props.theme.font.size.xsmall};
  line-height: ${(props) => props.theme.font.lineHeight.alt};
  color: var(--label-color-override, var(--c-text-muted));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  pointer-events: none;

  & ~ ${Select} {
    --text-offset-block-end: var(--gutter-block);
    --text-offset-block-start: calc(
      var(--height) - ((var(--text-size) * var(--line-height)) + var(--text-offset-block-end))
    );
  }
`;
